<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
  <div fxFlex>{{ data.title }}</div>
  <button mat-icon-button [mat-dialog-close]="false" *ngIf="!data.hideCancel" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
  <p>
    {{ data.text }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
    {{ data.actionTitle }}
  </button>
  <button *ngIf="data.showCancelBtn" type="button" mat-button [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>
